"use client";

import { useEffect, useRef } from "react";
import { TokenManager } from "@/lib/api/token-manager";
import { EntryPoint } from "@/types/api";

interface TokenProviderProps {
  children: React.ReactNode;
  serverToken?: string | null; // Token captured from server-side requests
}

export default function TokenProvider({
  children,
  serverToken,
}: TokenProviderProps) {
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only run once on mount
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    // If server provided a token and we don't have one locally, save it
    if (serverToken && !TokenManager.hasToken()) {
      console.log("🔑 TokenProvider: Saving server token to client storage");
      TokenManager.setToken(serverToken);
    } else if (serverToken && TokenManager.hasToken()) {
      const existingToken = TokenManager.getToken();
      // Update if server token is different
      if (existingToken !== serverToken) {
        TokenManager.setToken(serverToken);
      }
    }

    // Initialize client id if missing
    if (TokenManager.getClientId() === 0) {
      TokenManager.setClientId(0);
    }

    // Default entry point to home unless set elsewhere (per-page can override)
    if (!TokenManager.getEntryPoint()) {
      TokenManager.setEntryPoint(EntryPoint.HOME);
    }
  }, [serverToken]);

  return <>{children}</>;
}
